import React from 'react';
import {
  FormLabelProps,
  FormErrorMessageProps,
  HelpTextProps,
  StyleProps,
  CheckboxProps,
} from '@chakra-ui/react';

import HOCs from '../HOCs';
import CheckboxComponent from './Checkbox';

export type TCheckbox = {
  name: string;
  isFormik?: boolean;
  label?: string;
  error?: string;
  helperText?: string;
  propsLabel?: FormLabelProps;
  propsError?: FormErrorMessageProps;
  propsHelper?: HelpTextProps;
  sxWrapper?: StyleProps;
} & CheckboxProps;

export default function Checkbox({
  isFormik = true,
  name,
  label,
  error,
  helperText,
  propsLabel,
  propsError,
  propsHelper,
  sxWrapper,
  colorScheme,
  children,
  ...rest
}: TCheckbox) {
  const id = `${name}-checkbox`;

  return (
    <HOCs
      {...{
        isFormik,
        id,
        name,
        label,
        error,
        helperText,
        propsLabel,
        propsError,
        propsHelper,
        sxWrapper,
      }}
    >
      <CheckboxComponent
        id={id}
        name={name}
        colorScheme={colorScheme || 'accent'}
        {...rest}
      >
        {children}
      </CheckboxComponent>
    </HOCs>
  );
}
